import { render, staticRenderFns } from "./resourcesDetails.vue?vue&type=template&id=22f1cacd&scoped=true&"
import script from "./resourcesDetails.vue?vue&type=script&lang=js&"
export * from "./resourcesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1cacd",
  null
  
)

export default component.exports